<!-- <div class="mathjax-editor"> -->
<div class="mathjax-editor__buttons">
  <span
    class="mathjax-editor__buttons--button"
    *ngFor="let code of mathjaxCodes"
    (click)="addMathjaxContent(code.firstString, code.laststring)"
    >{{ code.label }}</span
  >
</div>
<!-- <textarea
    class="mathjax-editor__textarea"
    #mathjaxTextArea
    [(ngModel)]="text"
    rows="5"
  ></textarea> -->
<!-- </div> -->

<!-- <app-multi-data
  [multiData]="{
    type: 'MathJax',
    data: text,
    tikzId: '',
    imageKeys: [],
    listOfImages: null
  }"
></app-multi-data> -->
